import { fromJS } from 'immutable'

import {
  INVITE_USERS_POST,
  INVITE_USERS_UPDATE,
  INVITE_USERS_ERROR,
  INVITE_USERS_LIST_UPDATE,
  INVITE_USERS_LIST_DELETE,
} from 'actions/invite-users'

// Reducer
// ---------------------------------------------------------------------------

export const initialState = fromJS({
  error: false,
  errorData: null,
  loading: false,
  returnData: null,
  submitSuccess: false,
  inviteUsers: [],
})

export default function inviteUsersReducer(state = initialState, action) {
  switch (action.type) {
    case INVITE_USERS_POST:
      return _postInvitedUsers(state)
    case INVITE_USERS_UPDATE:
      return _updateInvitedUsers(state, action.payload)
    case INVITE_USERS_ERROR:
      return _errorInvitedUsers(state, action.payload)
    case INVITE_USERS_LIST_UPDATE:
      return _updateInvitedUsersList(state, action.payload)
    case INVITE_USERS_LIST_DELETE:
      return _deleteInvitedUsersList(state, action.payload)
    default:
      return state
  }
}

const _postInvitedUsers = state => {
  return state.update('loading', () => true)
}

const _updateInvitedUsers = (state, payload) => {
  return state
    .set('returnData', fromJS(payload.data))
    .update('loading', () => false)
    .update('error', () => false)
    .update('errorData', () => null)
    .update('submitSuccess', () => true)
}

const _errorInvitedUsers = (state, payload) => {
  return state
    .set('error', payload.error)
    .set('errorData', fromJS(payload.data))
    .update('loading', () => false)
}

const _updateInvitedUsersList = (state, payload) => {
  return state.set('inviteUsers', fromJS(payload.users))
}

const _deleteInvitedUsersList = (state, payload) => {
  return state.set(
    'inviteUsers',
    state.get('inviteUsers').delete(payload.index)
  )
}
